/**
 * Pull a readable message out of an API error response.
 *
 * st-core puts user-facing text in `display` or `message`. An exception that
 * was re-wrapped on the server nests it one level down (`message.message`),
 * and a validation failure returns `message` as an array. Anything else falls
 * back to the given text, so the toast never reads "[object Object]".
 */
export function apiErrorMessage(err: any, fallback: string): string {
  const body = err?.error;
  const candidates = [
    body?.display,
    body?.message,
    body?.message?.display,
    body?.message?.message,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate;
    }
    if (Array.isArray(candidate) && candidate.length > 0) {
      return candidate.join(", ");
    }
  }

  return fallback;
}
